import { render, staticRenderFns } from "./xjnyzyjsxy.vue?vue&type=template&id=c20da67e&scoped=true&"
import script from "./xjnyzyjsxy.vue?vue&type=script&lang=js&"
export * from "./xjnyzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./xjnyzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xjnyzyjsxy.vue?vue&type=style&index=1&id=c20da67e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20da67e",
  null
  
)

export default component.exports